// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__kRs9B","text":"SelectPayment_text__39Ay0","title":"SelectPayment_title__1JqJN","btn":"SelectPayment_btn__1PFcw"};